import React from 'react'
import styled from 'styled-components'
import { fonts } from '../Components/Styles/common-styles'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 26px 20px 20px 28px;
`
const MainTitle = styled.div`
  font-size:${fonts.extraLargePlusSize};
  padding: 5px;
  list-style: none;
  left: 0px;
  font-weight: 600;
}
`
const Title = styled.div`
  font-size:${fonts.extraLargeSize};
  padding: 18px 0px;
  list-style: none;
  left: 0px;
  font-weight: 400;
}
`
const SmallTitle = styled.div`
  font-size:${fonts.bigSize};
  padding: 18px 0px;
  list-style: none;
  left: 0px;
  font-weight: 600;
}
`
const Text = styled.div`
  font-size:${fonts.largeSize};
  padding: 18px 0px;
  left: 0px;
  font-weight: 400;
}
`
const DotList = styled.li`
font-size:${fonts.largeSize};
line-height: 150%;
`
const NumberedList = styled.li`
  font-size:${fonts.largeSize};
  list-style-type: none;
  line-height: 150%;
`
const Img = styled.img`
  width: 399px;
  height: 267px;
`

const dotListMockup = [
  {
    title: 'Keskustelujen pääteemat',
    list: ['Kysy neuvoa tai ideaa muilta',
      'Uudet menetelmät ja työkalut sekä sovellukset jo olemassa olevista',
      'Jaa oma suunnitelmasi, kokemuksesi tai vinkkisi',
      'Keskustele valmennussisällöistä ja niiden herättämistä ajatuksista'
    ]
  },
  {
    title: 'Keskustelun pelisäännöt',
    list: ['Osallistu aktiivisesti lukemalla, kirjoittamalla ja kommentoimalla.',
      'Keskustele kuhunkin teemaan liittyvistä aiheista oikean otsikon alla.',
      'Jaa tietoa ja opi muilta.',
      'Jokaisen panos yhteisölle on yhtä tärkeä.',
      'Arvosta erilaista tietoa, osaamista ja ajattelua.',
      'Näytä ja osoita arvostuksesi muille!',
      'Kannusta muita keskustelijoita.',
      'Ei omien tuotteiden myyntiä eikä markkinointia.',
      'Pidä hauskaa ja opi lisää upeilta kanssakeskustelijoilta!'
    ]
  }
]

// const numberListMockup = [
//   {
//     title: 'Ohje',
//     list: ['1. Kirjaudu osoitteessa Padlet.com.',
//       '2. Etusivullasi pitäisi nyt näkyä Luo Padlet -painike.',
//       '3. Tästä painamalla sinulle aukeaa alla esitetty näkymä, josta voit valita pohjan käyttöön.'
//     ]
//   }]

// const number2ListMockup = [
//   {
//     title: '',
//     list: ['4. Sinulle aukeaa nyt luomasi pohja.',
//       '5. Oikealta yläpalkista löydät asetukset. Asetuksissa          pääset muokkaamaan  esimerkiksi taustakuvaa sekä Padletin nimeä.',
//       '6. Padletin muokkaaminen tapahtuu kaksoisnapauttamalla, ala reunan lisäysmerkistä tai  suoraan raahaamalla haluttuja tiedostoja sekä kuvia. ',
//       '7. Osallistujille voit kopioida jaettavaksi linkin Padlettiisi joko asetuksista tai  sen vierestä Jaa-kuvakkeesta. Padletin pystyt myös jakamaan osallistujien  sähköpostiin halutessasi.',
//       '8. Jaa-kuvakkeen takana pystyt myös muokkaamaan yksityisasetuksia, esimerkiksi sellaisiksi,  että Padletin näkee vain salasanan avulla.'
//     ]
//   }]

const CommunityPage = () => {
  return (
    <Container>
      <MainTitle>Community</MainTitle>
      <Text>Yhdessä opimme ja olemme enemmän. Tässä yhteisössä jaamme kokemuksia erilaisten
        tilaisuuksien ja tilanteiden suunnittelusta sekä toteutuksesta. Vaihdamme ajatuksia,
        kysymme ja annamme neuvoja sekä kehitämme yksin ja yhdessä uusia menetelmiä ja
        työkaluja sekä sovelluksia jo olemassa olevista.</Text>

      {
        dotListMockup.map((item, index) =>
          <div key={index}>
            <SmallTitle>{item.title}</SmallTitle>
            {item.list.map(i => <DotList key={i}>{i}</DotList>)}
          </div>
        )
      }
      <Title>Padlet</Title>
      <Text>Padlet on hyvä työkalu yhteistyöhön etätapaamisessa. Padlettiin pystyy lisäämään
        esimerkiksi  tiedostoja, kuvia ja tekstejä. Ilmaisella käyttäjällä pystyy omistamaan
        3 yhtäaikaista Padlettia. Padletteja pystyy tallentamaan omalle koneelleen esimerkiksi
        PDF-muodossa tai Excel-muodossa,  jonka jälkeen, jos Padletin poistaa Padlet-tililtä on
        se tallessa, mutta vapautuu tilaa tehdä uusi  Padlet. Ilmaisellakin käyttäjällä pystyy
        siis käytännössä tehdä rajattoman määrän Padletteja. Jaettua Padlettia pystyy muokkaamaan
        ilman käyttäjätunnuksen tekemistä. </Text>

      <NumberedList>1. Kirjaudu osoitteessa Padlet.com.</NumberedList>
      <div style={{ display: 'flex' }}>
        <NumberedList>2. Etusivullasi pitäisi nyt näkyä Luo Padlet -painike. </NumberedList>
        <img src='/Images/luo.jpeg' style={{ width: '101px', height: '29px', margin: '0, 10px' }} />
      </div>
      <NumberedList>3. Tästä painamalla sinulle aukeaa alla esitetty näkymä, josta voit valita pohjan käyttöön. </NumberedList>

      <Img src='/Images/community.png' />
      <NumberedList>4. Sinulle aukeaa nyt luomasi pohja. </NumberedList>
      <div style={{ display: 'flex' }}>
        <NumberedList>5. Oikealta yläpalkista löydät asetukset. <img src='/Images/settings.png' style={{ width: '29px', height: '28px', margin: '0, 18px' }} /> Asetuksissa pääset muokkaamaan  esimerkiksi taustakuvaa sekä Padletin nimeä.  </NumberedList>
      </div>
      <NumberedList>6. Padletin muokkaaminen tapahtuu kaksoisnapauttamalla, ala reunan lisäysmerkistä tai  suoraan raahaamalla haluttuja tiedostoja sekä kuvia. </NumberedList>
      <div style={{ display: 'flex' }}>
        <NumberedList>7. Osallistujille voit kopioida jaettavaksi linkin Padlettiisi joko asetuksista tai  sen vierestä Jaa-kuvakkeesta. Padletin pystyt myös jakamaan osallistujien  sähköpostiin halutessasi. </NumberedList>
        <img src='/Images/share.jpeg' style={{ width: '69px', height: '37px', margin: '0, 10px' }} />
      </div>
      <NumberedList>8. Jaa-kuvakkeen takana pystyt myös muokkaamaan yksityisasetuksia, esimerkiksi sellaisiksi,  että Padletin näkee vain salasanan avulla. </NumberedList>

    </Container>
  )
}

export default CommunityPage
